import { useEffect, useState } from "react";
import PhoneMockup from "./PhoneMockup";
import { getWhatsAppLink, trackWhatsAppClick } from "@/lib/analytics";
import { MessageCircle } from "lucide-react";

export default function Hero({ content }) {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setAnimate(true), 300);
    return () => clearTimeout(t);
  }, []);

  return (
    <section id="top" className="relative overflow-hidden pt-32 pb-20 md:pt-44 md:pb-28" data-testid="hero-section">
      {/* Ambient glow background */}
      <div className="pointer-events-none absolute -top-20 left-1/4 h-96 w-96 rounded-full bg-yellow-600/10 blur-[100px]" />
      <div className="pointer-events-none absolute top-40 right-0 h-80 w-80 rounded-full bg-blue-600/10 blur-[100px]" />

      <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-6 md:grid-cols-2 md:px-12">
        <div
          className="transition-all duration-700"
          style={{
            opacity: animate ? 1 : 0,
            transform: animate ? "translateY(0)" : "translateY(24px)",
          }}
        >
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
            Meta Reklam Ajansı · Instagram &amp; Facebook
          </p>
          <h1 className="text-4xl font-light leading-tight tracking-tighter text-white sm:text-5xl lg:text-6xl">
            {content.hero_title}
          </h1>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-slate-400 md:text-lg">
            {content.hero_subtitle}
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a
              href={getWhatsAppLink(content.whatsapp_number)}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackWhatsAppClick("hero")}
              className="flex items-center gap-2 rounded-full bg-gold px-8 py-4 text-sm font-semibold text-black transition-colors hover:bg-gold-light"
              data-testid="hero-whatsapp-cta"
            >
              <MessageCircle className="h-5 w-5" />
              Şimdi WhatsApp'tan Yaz
            </a>
            <div className="flex items-center gap-2 text-sm text-slate-400">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
              </span>
              Genellikle 1 saat içinde yanıtlıyoruz
            </div>
          </div>
        </div>

        <div
          className="transition-all duration-700"
          style={{ opacity: animate ? 1 : 0, transitionDelay: "150ms" }}
        >
          <PhoneMockup animate={animate} />
        </div>
      </div>
    </section>
  );
}
